import { Breakpoints, Container, ContainerPadding, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { PortalContext } from '../../../../../context/PortalContext';
import { HuchaValues } from '../../models/hucha-values';
import { HuchaStandardBonusPopup } from './popup-hucha-standard';
import { RenovadorPlus15BonusPopup } from './popup-hucha-renovadores-plus15';
import { Renovador10To15BonusPopup } from './popup-hucha-renovadores-10-to-15';

export const HuchaPopupContent = ({
	huchaValues,
	portalContext,
	handlePopupClose,
}: {
	huchaValues: HuchaValues | null;
	portalContext: any;
	handlePopupClose: () => void;
}) => {
	const layerContent = () => {
		if (huchaValues?.huchaTier === 'standard') {
			return <HuchaStandardBonusPopup huchaValues={huchaValues} />;
		}

		if (huchaValues?.huchaTier === 'renovador10To15') {
			return <Renovador10To15BonusPopup huchaValues={huchaValues} />;
		}

		if (huchaValues?.huchaTier === 'renovadorPlus15') {
			return <RenovadorPlus15BonusPopup huchaValues={huchaValues} />;
		}
		return null;
	};

	return (
		<PortalContext.Provider value={portalContext}>
			<Container
				horizontalAlign={'flex-end'}
				padding={{
					top: ContainerPadding.dynamic0100,
					right: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b1600]: ContainerPadding.dynamic0100,
					},
					bottom: ContainerPadding.dynamic0100,
				}}
			>
				<CTA
					tag="button"
					emphasis="tertiary"
					onClick={handlePopupClose}
					aria-label="Close pop-up"
					icon={<Close variant="default" aria-hidden />}
				/>
			</Container>
			{layerContent()}
		</PortalContext.Provider>
	);
};
